import { EntEconomicActivityTypes } from "../../../models/handBooks/economicActivityTypes";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntEconomicActivityFilter } from "../../../models/filters/economicActivityFilter";
import { Paths } from "../../../paths";

export const economicActivityTypesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

    getEconomicActivityTypesList: builder.query<ResponseDataGet<EntEconomicActivityTypes>, EntEconomicActivityFilter>({
      query: (filter) => ({
        url: `${Paths.handbooks.economicactivitytypes}/get-all`,
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getEconomicActivityTypesById: builder.query<ResponseDataTest<EntEconomicActivityTypes>, number>({
      query: (id) => ({
        url: `${Paths.handbooks.economicactivitytypes}/${id}`,
        method: 'GET'
      })
    }),
    addEconomicActivityTypes: builder.mutation<ResponseDataTest<EntEconomicActivityTypes>, EntEconomicActivityTypes>({
      query: (body) => ({
        url: `${Paths.handbooks.economicactivitytypes}`,
        method: "POST",
        body: JSON.stringify(body)
      }),
    }),
    editEconomicActivityTypes: builder.mutation<ResponseDataTest<EntEconomicActivityTypes>, EntEconomicActivityTypes>({
      query: (body,) => ({
        url: `${Paths.handbooks.economicactivitytypes}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    }),
    deleteEconomicActivityTypes: builder.mutation<ResponseDataTest<EntEconomicActivityTypes>, number>({
      query: (id) => ({
        url: `${Paths.handbooks.economicactivitytypes}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetEconomicActivityTypesListQuery,
  useAddEconomicActivityTypesMutation,
  useEditEconomicActivityTypesMutation,
  useDeleteEconomicActivityTypesMutation
} = economicActivityTypesApi;
